import { CardMedia, Chip, Stack, Typography } from "@mui/material";
import { OnboardingStep } from "src/components/modal/senec-onboarding-dialog/commonTypes";
// prevents the dialog to have "big jumps" when switch between steps
// that have different content dimensions and its picture is still being loaded
const minCardMediaHeight = "270px";

export const OnboardingDialogStep = ({ step, stepMinHeight }: { step: OnboardingStep; stepMinHeight: string }) => {
    return (
        <Stack
            data-testid={"onboarding-step"}
            key={step.title}
            display={"flex"}
            direction={"column"}
            sx={{ ul: { m: 0, px: "1.5rem" } }}
            minHeight={stepMinHeight}
        >
            {step.image && (
                <CardMedia
                    component="img"
                    height={"auto"}
                    alt={step.image.description}
                    image={step.image.url}
                    title={step.image.title}
                    data-testid="card-image"
                    sx={{ mb: 3, minHeight: minCardMediaHeight }}
                />
            )}
            <Typography variant="h3" sx={{ mb: 3 }}>
                {step.title}
                {step.isNewLabel !== undefined && (
                    <Chip
                        data-testid={"data-qa-new-step-chip"}
                        label={step.isNewLabel}
                        color={"info"}
                        sx={{ width: "fit-content", ml: "1rem" }}
                    />
                )}
            </Typography>
            {step.DescriptionComponent}
        </Stack>
    );
};
